var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path12, _ellipse, _path13, _path14, _path15, _path16, _path17, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path18, _path19, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurveySuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 613,
    height: 441,
    viewBox: "0 0 613 441",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M100.886 108.773C99.696 112.672 98.9265 116.687 98.5907 120.749C96.8382 140.465 103.488 160.782 97.9291 180.308C91.2747 203.684 72.0121 221.193 64.1598 244.144C52.5573 278.057 53.1143 316.058 67.2047 349.104C73.9956 365.03 83.9158 379.832 97.4631 390.068C118.347 405.847 145.711 409.308 171.446 407.306C209.746 404.328 250.16 387.747 288.669 392.269C298.623 393.438 305.338 399.106 310.792 406.361C316.982 414.594 321.548 424.87 327.382 432.935C328.885 435.012 330.453 437.034 332.086 439.001H533.443C535.63 436.165 537.689 433.232 539.59 430.203C549.583 414.279 555.39 395.84 554.444 376.41C553.448 355.973 545.267 335.673 549.054 315.592C553.808 290.39 572.797 267.425 586.557 246.891C601.894 223.852 610.928 197.197 612.758 169.58C612.779 169.267 612.798 168.955 612.817 168.642C615.638 121.046 585.617 77.636 540.323 62.74L443.949 31.0447C418.802 22.6892 392.963 16.582 366.736 12.7949C349.567 10.3401 332.249 9.07275 314.905 9.00189C311.149 8.99255 307.399 9.05519 303.654 9.16523C253.008 10.5027 203.353 23.4996 158.547 47.1461C139.091 57.3597 107.411 87.7903 100.886 108.773Z",
    fill: "#C0D4E9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12981_265874)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.366595,
    y: 1.36816,
    width: 26.2608,
    height: 26.3119,
    rx: 7,
    transform: "matrix(0.865242 0.501354 -0.498647 0.866805 161.075 147.65)",
    fill: "white",
    stroke: "#1C4066",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.281 169.269C161.173 169.23 161.069 169.179 160.972 169.118C160.794 169.006 160.64 168.861 160.519 168.689C160.397 168.517 160.311 168.323 160.266 168.117L159.259 163.611C159.23 163.481 159.227 163.347 159.25 163.216C159.273 163.085 159.321 162.96 159.392 162.848C159.463 162.736 159.555 162.639 159.663 162.562C159.771 162.486 159.894 162.431 160.023 162.402C160.152 162.373 160.286 162.37 160.416 162.393C160.547 162.416 160.671 162.464 160.783 162.535C160.895 162.606 160.992 162.699 161.068 162.808C161.144 162.916 161.198 163.039 161.227 163.169L162.139 167.253L171.812 165.017C171.941 164.987 172.074 164.983 172.205 165.005C172.335 165.027 172.46 165.075 172.573 165.145C172.685 165.216 172.782 165.308 172.859 165.416C172.936 165.524 172.991 165.647 173.02 165.776C173.05 165.906 173.054 166.04 173.032 166.171C173.01 166.302 172.963 166.427 172.892 166.54C172.822 166.653 172.731 166.75 172.623 166.827C172.515 166.904 172.393 166.959 172.264 166.989L162.174 169.322C161.878 169.391 161.568 169.373 161.281 169.269Z",
    fill: "#3374B9"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M598.792 436.999H1.20762C0.540671 436.999 0 437.752 0 438.682V439.316C0 440.245 0.540671 440.999 1.20762 440.999H598.792C599.459 440.999 600 440.245 600 439.316V438.682C600 437.752 599.459 436.999 598.792 436.999Z",
    fill: "#15314E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67 210C73.0751 210 78 205.076 78 199C78 192.925 73.0751 188 67 188C60.9249 188 56 192.925 56 199C56 205.076 60.9249 210 67 210Z",
    fill: "#C0D4E9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92 66.5001C92 67.3901 91.7654 68.2602 91.3258 69.0002C90.8863 69.7402 90.2615 70.3169 89.5306 70.6575C88.7997 70.9981 87.9955 71.0872 87.2196 70.9135C86.4437 70.7399 85.7309 70.3113 85.1715 69.6819C84.6121 69.0526 84.2312 68.2508 84.0768 67.3779C83.9225 66.5049 84.0018 65.6002 84.3045 64.7779C84.6073 63.9556 85.12 63.2528 85.7777 62.7584C86.4355 62.2639 87.2089 62 88 62C88.5253 62 89.0455 62.1164 89.5308 62.3425C90.0161 62.5687 90.457 62.9002 90.8285 63.3181C91.1999 63.736 91.4945 64.2321 91.6956 64.778C91.8966 65.324 92 65.9092 92 66.5001Z",
    fill: "#76A2D0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M498 70.9994C498 71.7906 497.736 72.5639 497.242 73.2217C496.747 73.8795 496.044 74.3923 495.222 74.695C494.4 74.9978 493.495 75.077 492.622 74.9227C491.749 74.7683 490.947 74.3873 490.318 73.8279C489.689 73.2685 489.26 72.5558 489.086 71.7799C488.913 71.0039 489.002 70.1997 489.343 69.4688C489.683 68.7378 490.26 68.1131 491 67.6736C491.74 67.2341 492.61 66.9995 493.5 66.9995C494.694 66.9995 495.838 67.421 496.682 68.1711C497.526 68.9212 498 69.9386 498 70.9994Z",
    fill: "#A1BFDF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5 277.999C81.9853 277.999 84 276.208 84 273.999C84 271.79 81.9853 269.999 79.5 269.999C77.0147 269.999 75 271.79 75 273.999C75 276.208 77.0147 277.999 79.5 277.999Z",
    fill: "#3374B9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M560 208C562.209 208 564 206.21 564 204C564 201.791 562.209 200 560 200C557.791 200 556 201.791 556 204C556 206.21 557.791 208 560 208Z",
    fill: "#3374B9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M540 289.499C540 290.982 539.56 292.432 538.736 293.666C537.912 294.899 536.741 295.86 535.37 296.428C534 296.996 532.492 297.144 531.037 296.855C529.582 296.565 528.246 295.851 527.197 294.802C526.148 293.753 525.434 292.417 525.144 290.962C524.855 289.507 525.003 287.999 525.571 286.629C526.139 285.258 527.1 284.087 528.333 283.263C529.567 282.439 531.017 281.999 532.5 281.999C533.485 281.999 534.46 282.193 535.37 282.57C536.28 282.947 537.107 283.499 537.803 284.195C538.5 284.892 539.052 285.719 539.429 286.629C539.806 287.539 540 288.514 540 289.499Z",
    fill: "#3374B9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M345 9.00006C345 10.7801 344.472 12.5201 343.483 14.0002C342.494 15.4802 341.089 16.6338 339.444 17.3149C337.8 17.9961 335.99 18.1743 334.244 17.8271C332.498 17.4798 330.895 16.6226 329.636 15.3639C328.377 14.1052 327.52 12.5016 327.173 10.7557C326.826 9.00992 327.004 7.20032 327.685 5.55579C328.366 3.91126 329.52 2.50566 331 1.51673C332.48 0.527814 334.22 -1.31778e-05 336 2.46734e-10C337.182 -7.00007e-06 338.352 0.23278 339.444 0.685074C340.536 1.13737 341.528 1.80031 342.364 2.63605C343.2 3.47178 343.863 4.46395 344.315 5.55589C344.767 6.64783 345 7.81816 345 9.00006Z",
    fill: "#3374B9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M516 136.998C519.314 136.998 522 134.312 522 130.998C522 127.685 519.314 124.998 516 124.998C512.686 124.998 510 127.685 510 130.998C510 134.312 512.686 136.998 516 136.998Z",
    fill: "#3374B9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M429 389.347C429 406.276 415.27 420.001 398.331 420.001H225.669C208.73 420.001 195 406.276 195 389.347V116.656C195 99.7273 208.73 86.0015 225.669 86.0015H374.013L429 140.719V389.347Z",
    fill: "#F5FAFE",
    stroke: "#15314E",
    strokeWidth: 6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 242.156,
    y: 185.926,
    width: 122.347,
    height: 7.06659,
    rx: 3.5333,
    fill: "#A1BFDF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 242.156,
    y: 202.412,
    width: 141.169,
    height: 7.06659,
    rx: 3.5333,
    fill: "#A1BFDF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 242.156,
    y: 237.747,
    width: 122.347,
    height: 7.06659,
    rx: 3.5333,
    fill: "#A1BFDF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 242.156,
    y: 254.233,
    width: 141.169,
    height: 7.06659,
    rx: 3.5333,
    fill: "#A1BFDF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 242.156,
    y: 289.568,
    width: 122.347,
    height: 7.06659,
    rx: 3.5333,
    fill: "#A1BFDF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 242.156,
    y: 306.054,
    width: 141.169,
    height: 7.06659,
    rx: 3.5333,
    fill: "#A1BFDF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 242.156,
    y: 341.393,
    width: 122.347,
    height: 7.06659,
    rx: 3.5333,
    fill: "#A1BFDF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 242.156,
    y: 357.879,
    width: 141.169,
    height: 7.06659,
    rx: 3.5333,
    fill: "#A1BFDF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M373 121.548C373 132.844 382.157 142.001 393.453 142.001H432V139.641L375.36 83.0015H373V121.548Z",
    fill: "#15314E"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 46.7947,
    ry: 46.8414,
    transform: "matrix(0.965851 -0.259097 0.258541 0.966 408.792 376.87)",
    fill: "#5C9FDC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M369.527 376.082C368.385 376.059 367.473 375.114 367.553 373.974C367.942 368.418 369.448 362.991 371.988 358.02C374.528 353.049 378.043 348.651 382.315 345.084C383.192 344.352 384.492 344.539 385.178 345.452C385.865 346.365 385.677 347.658 384.805 348.395C381.031 351.582 377.923 355.493 375.669 359.905C373.414 364.317 372.065 369.129 371.692 374.057C371.606 375.197 370.668 376.105 369.527 376.082Z",
    fill: "#EBF1F8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M387.405 343.892C386.783 342.934 387.053 341.647 388.04 341.074C390.773 339.486 393.678 338.217 396.699 337.292C397.791 336.957 398.916 337.634 399.195 338.743C399.474 339.851 398.801 340.97 397.711 341.31C395.129 342.117 392.642 343.203 390.295 344.55C389.304 345.118 388.026 344.851 387.405 343.892Z",
    fill: "#EBF1F8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M408.07 391.456C407.813 391.905 407.388 392.232 406.887 392.366C406.386 392.5 405.854 392.431 405.407 392.171L391.926 384.378C390.527 383.569 390.048 381.78 390.856 380.379L391.83 378.689C392.638 377.288 394.425 376.809 395.825 377.618L404.242 382.483L417.373 359.713C418.181 358.312 419.968 357.833 421.367 358.642L423.055 359.617C424.454 360.426 424.933 362.215 424.125 363.616L408.07 391.456Z",
    fill: "#FDFEFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M393.602 377.324C392.879 377.518 392.23 377.988 391.826 378.69L390.852 380.38C390.044 381.781 390.523 383.57 391.922 384.379L405.404 392.171C405.852 392.431 406.384 392.5 406.885 392.366C407.386 392.232 407.811 391.905 408.068 391.456L411.229 385.975L408.375 375.311L404.24 382.483L395.823 377.618C395.122 377.212 394.326 377.13 393.602 377.324Z",
    fill: "#EEF6FD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7073 77.9983H273.535C276.64 77.9983 279.618 79.2331 281.813 81.4312C284.009 83.6292 285.242 86.6104 285.242 89.7189V118.128C285.242 121.236 284.009 124.218 281.813 126.416C279.618 128.614 276.64 129.849 273.535 129.849H72.7073C69.6024 129.849 66.6245 128.614 64.429 126.416C62.2334 124.218 61 121.236 61 118.128V89.7191C61 86.6105 62.2334 83.6293 64.429 81.4312C66.6245 79.2332 69.6024 77.9983 72.7073 77.9983Z",
    fill: "#DFECFA"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.6878,
    cy: 104.09,
    rx: 13.0315,
    ry: 13.0465,
    fill: "#749DD3"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.407,
    cy: 104.09,
    rx: 13.0315,
    ry: 13.0465,
    fill: "#749DD3"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.125,
    cy: 104.09,
    rx: 13.0315,
    ry: 13.0465,
    fill: "#749DD3"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 214.844,
    cy: 104.09,
    rx: 13.0315,
    ry: 13.0465,
    fill: "#749DD3"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 256.563,
    cy: 104.09,
    rx: 13.0315,
    ry: 13.0465,
    fill: "#749DD3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M129.388 111.594L123.625 105.281L126.288 102.796L129.203 105.989L136.442 96.9163L139.263 99.2174L129.388 111.594Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M260.875 145.619L238.703 123.422H260.875V145.619Z",
    fill: "#DFECFA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12981_265874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.2608,
    height: 28.3119,
    rx: 8,
    transform: "matrix(0.865242 0.501354 -0.498647 0.866805 160.344 147.651)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveySuccess);
export default __webpack_public_path__ + "static/media/SurveySuccess.c9304363d23e8ee2c0a5b96629b2a644.svg";
export { ForwardRef as ReactComponent };